
import React from "react";

function About() {
    return (
        <section
            id="about"
            className="relative overflow-hidden bg-sunrise py-20 sm:py-24 lg:py-28"
        >
            {/* Decorative glow */}
            <div className="pointer-events-none absolute -left-32 top-10 h-72 w-72 rounded-full bg-sunrise-500/20 blur-3xl" />
            <div className="pointer-events-none absolute -right-32 bottom-0 h-80 w-80 rounded-full bg-blush-500/20 blur-3xl" />

            <div className="section relative">
                <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">

                    {/* Image */}
                    <div className="relative">
                        <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-sunrise-500/20 to-blush-500/20 blur-xl" />

                        <div className="glass relative overflow-hidden rounded-[2rem] p-3">
                            {/* <div className="flex aspect-[4/5] items-center justify-center overflow-hidden rounded-[1.5rem] bg-dusk-900">
                                <div className="text-center">
                                    <div className="mb-4 text-6xl">💄</div>

                                    <p className="font-display text-xl text-white/80">
                                        Sree Sunrise
                                    </p>

                                    <p className="mt-1 text-sm tracking-[0.2em] text-sunrise-300">
                                        MAKEUP STUDIO
                                    </p>
                                </div>
                            </div> */}
                            <div className="aspect-[4/5] overflow-hidden rounded-[1.5rem]">
    <img
        src="/images/Ks15.jpg"
        alt="Sree Sunrise Makeup Studio"
        className="h-full w-full object-cover"
    />
</div>
                        </div>

                        {/* Experience */}
                        <div className="absolute -bottom-6 -right-4 rounded-2xl border border-white/10 bg-dusk-900/90 px-6 py-4 shadow-glow backdrop-blur-xl">
                            <p className="font-display text-3xl font-bold text-sunrise-400">
                                5+
                            </p>

                            <p className="text-xs font-medium uppercase tracking-wider text-white/60">
                                Years Experience
                            </p>
                        </div>
                    </div>

                    {/* Content */}
                    <div>
                        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-sunrise-400">
                            About Us
                        </p>

                        <h2 className="mt-4 font-display text-4xl font-bold leading-tight text-white sm:text-5xl">
                            Beauty That
                            <span className="block text-blush-400">
                                Tells Your Story
                            </span>
                        </h2>

                        <div className="mt-6 h-1 w-16 rounded-full bg-gradient-to-r from-sunrise-500 to-blush-500" />

                        <p className="mt-7 text-lg leading-8 text-white/80">
                            Welcome to{" "}
                            <span className="font-semibold text-sunrise-300">
                                Sree Sunrise Makeup Studio
                            </span>
                            , where beauty, elegance and confidence come
                            together.
                        </p>

                        <p className="mt-4 leading-7 text-white/60">
                            We create personalized makeup looks designed to
                            enhance your natural beauty and make every special
                            moment unforgettable. Whether it is your wedding
                            day, a celebration, a photoshoot or a special
                            occasion, we make sure you look and feel your very
                            best.
                        </p>

                        {/* Features */}
                        <div className="mt-8 grid gap-5 sm:grid-cols-2">

                            <div className="glass rounded-2xl p-5">
                                <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-sunrise-500/15 text-xl">
                                    ✨
                                </div>

                                <h3 className="font-display text-lg font-semibold text-white">
                                    Professional Makeup
                                </h3>

                                <p className="mt-1 text-sm leading-6 text-white/50">
                                    Expertly crafted looks for every occasion.
                                </p>
                            </div>

                            <div className="glass rounded-2xl p-5">
                                <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-blush-500/15 text-xl">
                                    💕
                                </div>

                                <h3 className="font-display text-lg font-semibold text-white">
                                    Personalized Looks
                                </h3>

                                <p className="mt-1 text-sm leading-6 text-white/50">
                                    Makeup designed around your unique beauty.
                                </p>
                            </div>

                            <div className="glass rounded-2xl p-5">
                                <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-sunrise-500/15 text-xl">
                                    👰
                                </div>

                                <h3 className="font-display text-lg font-semibold text-white">
                                    Bridal Makeup
                                </h3>

                                <p className="mt-1 text-sm leading-6 text-white/50">
                                    Elegant bridal looks for your special day.
                                </p>
                            </div>

                            <div className="glass rounded-2xl p-5">
                                <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-blush-500/15 text-xl">
                                    🌸
                                </div>

                                <h3 className="font-display text-lg font-semibold text-white">
                                    Premium Experience
                                </h3>

                                <p className="mt-1 text-sm leading-6 text-white/50">
                                    Relax, enjoy and let us create your look.
                                </p>
                            </div>

                        </div>

                        {/* Button */}
                     {/* Button */}
<div className="mt-9">
    <a
        href="#contact"
        className="btn-primary"
    >
        Book Your Appointment
        <span>→</span>
    </a>
</div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;

